import 'url-search-params-polyfill'
import fetch from 'unfetch'
import ctx from '@/app'
import vsbl from 'vsbl'
import { formatMoney } from '@/lib/currency.js'

export function sortByArray(array, order, key){
    array.sort( function (a, b) {
        var A = a[key], B = b[key]
        
        if (order.indexOf(A) > order.indexOf(B)) {
            return 1
        } else {
            return -1
        }
    })
    
    return array
}

function compare(a, b, numb) {
    let comparison = 0

    if(a > b)
        comparison = 1
    else if( a < b )
        comparison = -1

    return comparison * numb
}

export function getDuplicates(array, integer){
    const lookup = array.reduce((a, e) => {
        a[e.id] = ++a[e.id] || 0;
        return a;
    }, {});

    return array.filter(e => lookup[e.id] === (integer - 1))
}

export function getUniques(array){
    return array.filter((item, pos) => array.indexOf(item) === pos)
}

function setUrlParams(parameters, shouldSetPriceParam) {
    let url = new URL(window.location.href)
    let params = new URLSearchParams(url.search.slice(1))
    parameters.forEach(({ name, value }) => {
        if( value != "" ) {
            if ( name == 'price' && shouldSetPriceParam ) {
                params.set(name, encodeURIComponent(value))
            } else if (name != 'price') {
                params.set(name, encodeURIComponent(value))
            }
        } else { 
            params.delete(name)
        }
    })

    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`)
}

export async function fetchByUrl(initialUrl){

    let allProducts = []
    let url = initialUrl

    let page = 1

    do {
        const startTime = new Date().getTime()

        const response = await fetch(url)
        const { next_page, products } = (await response.json()).data

        page++
        console.log(`fetched page ${page} in ${new Date().getTime() - startTime} ms`)

        url = next_page
        allProducts = [...allProducts, ...products.filter(p => p.published_at)]

    } while( url )

    return allProducts

}

function getProductPromises() {
    const { handle, collectionSize } = ctx.getState().filter.config

    let allPromises = []
    const productsPerPage = 1000;
    const pagesToIterate = Math.ceil(collectionSize / productsPerPage);

    for (let i = 0; i < pagesToIterate; i++) {
        allPromises.push(fetch(`/collections/${handle}?view=data&page=${i+1}`));
    }
    return allPromises;
}

function generateProductArray(promisesArr) {

    return Promise.all(promisesArr).then(responses =>
        Promise.all(responses.map(res => res.json()))
    ).then(data => {
        data = [].concat.apply([], data)
        return data;
    })
}

export async function fetchProducts(){
    const { store, id, limit } = ctx.getState().filter.config
    const startTime = new Date().getTime()

    const productPromises = getProductPromises();
    const productsInSeperateArrays = await generateProductArray(productPromises)
    console.log(`fetched all products in ${new Date().getTime() - startTime} ms`);

    let allProducts = []
    
    productsInSeperateArrays.forEach(arr => {
        allProducts = [...allProducts, ...arr.products.filter(p => p.published_at)]
    });
    
    const array = [
        allProducts
    ]
    
    if( id ) array.push(array[0])

    return Promise.all(array).then(([ products, sortedProducts ]) => {
        const prices = products.map(p => Number(p.variants[0].price))
        ctx.emit('filter:loaded', ({ filter }) => ({ filter: {
            ...filter,
            products: sortProducts('best-selling', products, sortedProducts || products),
            sorted: sortedProducts || products,
            prices: {
                min: Math.min(...prices),
                max: Math.max(...prices)
            }
        }}))
    })
}

export function sortProducts(value, array, sortedArray){

    const { filter } = ctx.getState()

    const clonedArray = [...array || filter.products]
    const sorted = sortedArray || filter.sorted

    switch (value) {
        case 'best-selling':
            sortByArray(clonedArray, sorted.map(p => p.id), 'id')
            break;

        case 'manual':
            sortByArray(clonedArray, sorted.map(p => p.id), 'id')
            break;

        case 'title-ascending':
            clonedArray.sort(({ title: a }, { title: b }) => compare(a.toUpperCase(), b.toUpperCase(), 1))
            break;

        case 'title-descending':
            clonedArray.sort(({ title: a }, { title: b }) => compare(a.toUpperCase(), b.toUpperCase(), -1))
            break;

        case 'price-ascending':
            clonedArray.sort(({ variants: [{price: a}] }, { variants: [{price: b}] }) => a - b)
            break;

        case 'price-descending':
            clonedArray.sort(({ variants: [{price: a}] }, { variants: [{price: b}] }) => b - a)
            break;

        case 'created-ascending':
            clonedArray.sort(({ created_at: a }, { created_at: b }) => new Date(a).getTime() - new Date(b).getTime())
            break;

        case 'created-descending':
            clonedArray.sort(({ created_at: a }, { created_at: b }) => new Date(b).getTime() - new Date(a).getTime())
            break;
    
        default:
            console.error(`No sorting function for ${value}`)
            break;
    }

    return clonedArray
}

function resetPagination(){
    const { filter } = ctx.getState()
    ctx.hydrate({ filter: {...filter, page: 1}})
}

function initFilters(filter, config){

    const { type, name, title, listType } = filter.dataset
    let items = [...filter.querySelectorAll(config.filterItems || '[data-filter-item]')]
    
    const obj = {
        type: type,
        name: name,
        title: title,
        async: filter.dataset.async != undefined ? true : false,
        dynamic: filter.dataset.dynamic != undefined ? true : false,
    }

    const findEligibleProducts = (array) => {
        return getUniques([...array].map(p => {
            let [key, subKey] = obj.type.split('.')
            
            if (key === 'variants' && subKey) {
                return p[key].filter(v => v.inventory_quantity > 0).map(v => v[subKey])
            }

            else if (subKey) return p[key].map(s => s[subKey])
            else return p[key]
        }).flat(1))
    }

    const bindItemsEvent = () => {
        obj.items = items
        items.forEach(item => {
            let input = item.tagName == 'INPUT' || item.tagName == 'SELECT'
    
            item.addEventListener(input ? 'change' : 'click', () => {
                if( !input ) item.classList.toggle(config.activeClass || 'active')
                ctx.emit('filter:start')
            })
        })
    }

    if( obj.async ){
        ctx.on('filter:loaded', state => {

            const { products } = state.filter

            let asyncFilterItems = findEligibleProducts(products)

            if (obj.type === 'product_type' || obj.type === 'vendor') asyncFilterItems.sort((a,b) => {
                if (a > b) return 1
                if (a < b) return -1
                return 0
            })

            if (obj.name === 'size') {
                const sizeFilterOrder = document.querySelector('.js-sizeFilterOrder').value.split(',')
                let newArray = [];

                sizeFilterOrder.forEach(function(size) {
                    if (size.indexOf('doubleQuote') != -1) {
                        newArray.push(size.replace('doubleQuote', '"'));
                    } else {
                        newArray.push(size);
                    }
                });

                asyncFilterItems = asyncFilterItems.sort((a, b) => {
                    if (newArray.indexOf(a.trim()) > newArray.indexOf(b.trim())) return 1
                    if (newArray.indexOf(a.trim()) < newArray.indexOf(b.trim())) return -1
                    return 1
                })
            }

            filter.innerHTML = config.render && config.render[listType] ? asyncFilterItems.map(config.render[listType]).join('') : null ?? `Please add a renderFunction, for ${listType} in your filter settings`
            items = [...filter.querySelectorAll(config.filterItems || '[data-filter-item]')]
            bindItemsEvent()
        })
    } else {
        bindItemsEvent()
    }

    if( type == 'price' ){
        ctx.on('filter:loaded', ({ filter }) => {
            obj['values'] = [filter.prices.min, filter.prices.max]
            items[0].dataset.min = filter.prices.min
            items[0].dataset.max = filter.prices.max
        })
    }

    if(obj.dynamic){
        ctx.on('filter:query', (state, query) => {
            const allButCurrentFilters = query.filter(q => q.params.length && q.name != obj.name)
            const allProducts = [].concat(...allButCurrentFilters.map(q => q.products))
            const products = getUniques(getDuplicates(allProducts, allButCurrentFilters.length))
            const possible = findEligibleProducts(products)

            obj.items.map(item => {
                item.style.display = !possible.includes(item.dataset.value) && possible.length && !item.classList.contains(config.activeClass || 'active') ? 'none' : null
            })
        })
    }

    return obj
}

function createQuery(state, paginate){
    const { filters, products } = state.filter
    const { activeClass } = state.filter.config.selectors

    let query = []

    if( !paginate ) resetPagination()

    filters.forEach(filter => {
        let obj = {
            ...filter
        }
        
        obj.activeItems = filter.items.filter(i => i.classList.contains(activeClass))

        if( filter.type == 'price' ) obj.params = [ Number(filter.items[0].dataset.min || 0), Number(filter.items[0].dataset.max || filter.items[0].value) ]
        else obj.params = obj.activeItems.map(i => i.dataset.value || Number(i.value))

        obj.products = obj.params.length == 0 ? products : products.filter(product => {
            let [key, subKey] = filter.type.split('.')
            let [min, max] = obj.params
            let [variant] = product.variants
            
            if (obj.type === 'product_type' && obj.params.find(p => product[key] === p)) return product
            else if(obj.type != 'product_type' && obj.params.filter(p => product[key] ? product[key].includes(p) : '').length ) return product

            // If looking in variants, only return product if a matching available variant is found
            else if (key === 'variants' && subKey) {
                if (product['variants'].find(v => obj.params.filter(p => v[subKey] === p).length && v.inventory_quantity > 0)) return product
            }

            else if(subKey && product[key].filter(s => obj.params.filter(p => s[subKey] === p).length).length) return product
            else if(filter.type == 'price' && Number(variant[key]) >= min && Number(variant[key]) <= max) return product
        })

        query.push(obj)
    })

    ctx.emit('filter:query', null, query)
}
// 😅
let isFirstProductQuery = false;
function queryProducts(state, query){
    const { filters } = state.filter

    let totalProducts = []
    
    query.forEach(q => {
        totalProducts = [...totalProducts, ...q.products]
    })

    totalProducts = getDuplicates(totalProducts, filters.length)
    totalProducts = getUniques(totalProducts)
    if (isFirstProductQuery) {
        var shouldSetPriceParam = false;
        const priceParams = query.filter(i => i.type == 'price')[0];
        const filterPriceParams = filters.filter(i => i.type == 'price')[0];
        if (priceParams.params[0] != filterPriceParams.values[0] || priceParams.params[1] != filterPriceParams.values[1]) {
            shouldSetPriceParam = true;
        }
        setUrlParams(query.map(q => ({ name: q.name, value: q.params.join(',') })), shouldSetPriceParam)
    } else {
        isFirstProductQuery = true;
    }

    ctx.emit('filter:render', ({ filter }) => ({ filter: { ...filter, pagination: { limit: totalProducts.length, showing: Math.max(0, Math.min(filter.page * filter.config.paginate, totalProducts.length)) }} }), totalProducts)
}

function renderProducts(state, products){
    const { filter } = state
    const { config, page, skipRender } = filter

    if (skipRender) {
        ctx.hydrate({ filter: {...filter, skipRender: false}})
        return
    }

    const pageAmount = config.paginate * page
    const renderedProducts = sortProducts(config.sorting.value || 'best-selling', [...products])
    renderedProducts.length = pageAmount

    config.output.innerHTML = ''

    renderedProducts.forEach(p => config.renderItem({
        product: p,
        parentEl: config.output,
        middleMan: true,
        wrapper: {
            elementType: 'li',
            className: 'grid__item'
        }
    }))
}

function initSorting(){
    const { config } = ctx.getState().filter

    //setUrlParams([{ name: 'sort_by', value: config.sorting.value }])
    
    config.sorting.addEventListener('change', () => {
        setUrlParams([{ name: 'sort_by', value: config.sorting.value }])
        ctx.emit('filter:start', null, true)
    })
}

let isFirstFilterRender = false;
function initPagination(){
    const { config } = ctx.getState().filter
    const { element, type } = config.pagination

    let listener
    let shouldEmit = true

    ctx.on('filter:render', ({ filter }, products) => {
        shouldEmit = (filter.page * config.paginate) >= products.length ? false : true
        element.style.display = (filter.page * config.paginate) >= products.length ? 'none' : null
        if (isFirstFilterRender) {
            setUrlParams([{ name: 'page', value: filter.page }])
        } else {
            isFirstFilterRender = true;
        }
    })

    const emit = () => {
        ctx.emit('filter:start', ({ filter }) => ({ filter: { ...filter, page: ++filter.page }}), true)
    }

    switch (type) {
        case 'button':
            element.addEventListener('click', emit)
            break;
        
        case 'infinite':
            listener = vsbl(element, { threshold: -1.5 })(() => shouldEmit && emit())
            break;

        default:
            break;
    }
    
}

function readUrlParams(){
    const { filter } = ctx.getState()
    const { config } = filter
    const urlParams = new URLSearchParams(location.search)
    
    for(let [name, value] of urlParams){
        let values = decodeURIComponent(value).split(',')
        let filter = config.element.querySelector(`${config.selectors.filter}[data-name="${name}"]`)

        let [item, ...items] = filter ? [...filter.querySelectorAll(config.selectors.filterItem)] : []

        if(filter) for(let v of values) !items.length ? item.value = v : filter.querySelector(`${config.selectors.filterItem}[data-value="${v}"]`).classList.add(config.selectors.activeClass)

        const filterData = ctx.getState().filter.filters.find(f => f.name === name)
        if (filterData && filterData.type === 'price') {
            filterData.items[0].dataset.min = values[0]
            filterData.items[0].dataset.max = values[1]
            document.querySelector('.js-minInput').placeholder = formatMoney(values[0] * 100);
            document.querySelector('.js-maxInput').placeholder = formatMoney(values[1] * 100);
            const fill = document.querySelector('.js-fill');

            let percentLeft = ((values[0] - ctx.getState().filter.prices.min) / (ctx.getState().filter.prices.max - ctx.getState().filter.prices.min)) * 100
            let percentRight = ((values[1] - ctx.getState().filter.prices.min) / (ctx.getState().filter.prices.max - ctx.getState().filter.prices.min)) * 100

            document.querySelector('.js-minRange').value = values[0]
            document.querySelector('.js-maxRange').value = values[1]
            fill.style.left = `${percentLeft}%`
            fill.style.right = `${100 - percentRight}%`
        }
    }

    if (!Array.from(urlParams).length) ctx.hydrate({ filter: {...filter, skipRender: true}})

    ctx.emit('filter:start', null, true)
}

export default function grafikrFilter(element, config = {}){

    const filters = [...element.querySelectorAll(config.filters || '[data-filter]')].map(f => initFilters(f, config))
    
    ctx.hydrate({
        filter: {
            config: {
                ...config,
                output: config.output,
                element: element,
                store: Shopify.shop.replace('.myshopify.com', ''),
                limit: Math.min(config.limit, 250) || 250,
                paginate: config.paginate || 16,
                selectors: {
                    filter: config.filters || '[data-filter]',
                    filterItem: config.filterItems || '[data-filter-item]',
                    activeClass: config.activeClass || 'active'
                },
                pagination: {
                    element: config.pagination.element,
                    type: config.pagination && config.pagination.type || 'button'
                },
                sorting: config.sorting
            },
            filters: filters,
            page: Number(new URLSearchParams(location.search).get('page')) || 1
        }
    })

    ctx.on('filter:loaded', ({ filter }) => {
        initPagination()
        readUrlParams()
        if(filter.config.sorting) initSorting()
    })

    ctx.on('filter:start', createQuery)
    ctx.on('filter:query', queryProducts)
    ctx.on('filter:render', renderProducts)
    fetchProducts()
}